module.exports = __webpack_public_path__ + "assets/img/driver-active-btn-b15d9b7b.png";